<template>
	<div class="login">
		<div class="logo" @click="toHome">
			<img src="../../assets/images/icon/logo.png" alt="">
		</div>
		<div class="login_box">
			<div class="title">Log in</div>
			<div class="input_box">
				<img src="../../assets/images/icon/user.png" alt="">
				<input type="text" v-model="email" placeholder="Email">
			</div>
			<div class="input_box">
				<img src="../../assets/images/icon/pwd.png" alt="">
				<input type="password" v-model="pwd" placeholder="Password">
			</div>
			<div class="btn_list flex align-center is-justify-end">
				<!-- <div class="agree flex align-center" @click="selectStatus = !selectStatus">
					<div class="select" v-if="!selectStatus"></div>
					<img class="select" v-else  src="../../../src/assets/images/icon/select_active.png" alt="">
					<div>I hereby agree to <span @click="toTerm">《terms and conditions》</span></div>
				</div> -->
				<div class="forget" @click="toFileInfo">Forgot password?</div>
				
			</div>
			<div class="submit" @click="submit">Log in</div>
			<div class="create_btn" @click="toRegister">Create a Curiouser Account</div>
		</div>
		<div class="bottom_help flex align-center justify-center">
			<div><span>Contact : info@Curiouser-family.com </span> Telephone: +44 (0)7462258770</div>
			<!-- <div class="help">帮助</div> -->
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				email:'',
				pwd:'',
				selectStatus:false,
				submitStatus:false
			}
		},
		methods:{
			submit(){
				if(this.submitStatus){
					return
				}
				var params = {
					password:this.pwd,
					email:this.email,
				}
				if(!this.pwd){
					this.$message('Please enter a password')
					return
				}
				// if(!this.selectStatus){
				// 	this.$message('Please agree to the Terms and Conditions')
				// 	return
				// }
				if(!this.email){
					this.$message('Please enter a valid email address')
					return
				}
				this.submitStatus = true
				this.$api.post('user/login',params,res=>{
					if(res.code == 1){
						this.$message('Successful')
						localStorage.setItem('token',res.data.token)
						// this.$router.push('/home')
						this.$router.back()
					}else{
						this.submitStatus = false
						this.$message(res.msg)
					}
				})
			},
			toFileInfo(){
				this.$router.push('/forget')
			},
			toRegister(){
				this.$router.push('/register')
			},
			toTerm(){
				this.$router.push('/term')
			},
			toHome(){
				this.$router.push('/home')
			}
		}
	}
</script>

<style scoped lang="scss">
	.login{
		width: 100%;
		min-height: 100vh;
		background-color: #F7F2EB;
		padding-top: 70px;
		padding-bottom: 40px;
		.logo{
			width: 557px;
			height: 122px;
			margin: 0 auto;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.login_box{
			width: 550px;
			height: 536px;
			background: #F7F2EB;
			box-shadow: 0px 8px 16px 0px rgba(92, 112, 122, 0.3);
			border-radius: 10px;
			margin: 60px auto;
			padding: 30px;
			.title{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-bottom: 20px;
			}
			.input_box{
				// width: 472px;
				padding-bottom:30px;
				padding-top: 48px;
				position: relative;
				margin-left: 55px;
				border-bottom: 1px solid #CCCCCC;
				img{
					width: 25px;
					height: 28px;
					position: absolute;
					left: 0;
					top: 48px;
				}
				input{
					width: 100%;
					font-size: 16px;
					line-height: 40px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #999999;
					padding-left: 50px;
				}
			}
			.btn_list{
				padding: 20px 0 0 55px;
				justify-content: flex-end;
				.agree{
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					cursor: pointer;
					span{
						color: #5C707A;
					}
					.select{
						width: 14px;
						height: 14px;
						border: 1px solid #282E30;
						border-radius: 50%;
						margin-right: 5px;
					}
				}
				.forget{
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #5C707A;
					cursor: pointer;
					margin-left: 10px;
				}
			}
			.submit{
				width: 180px;
				height: 50px;
				background: #5C707A;
				border-radius: 29px;
				margin: 70px auto 0;
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				line-height: 50px;
				text-align: center;
				cursor: pointer;
			}
			.create_btn{
				text-align: center;
				margin-top: 10px;
				cursor: pointer;
				text-decoration: underline;
			}
		}
		.bottom_help{
			margin-top: 160rpx;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			span{
				margin-right: 50px;
			}
			.help{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				margin-left: 56rpx;
				cursor: pointer;
			}
		}
	}
</style>